export default {
  pt: {
    pageTitle: "Seus dados",
    mainTitle: "Complete seu cadastro",
    cpfLabel: "CPF",
    birthDateLabel: "Data de nascimento",
    birthDateRequired: "Informe sua data de nascimento",
    birthDateInvalid: "Data de nascimento inválida",
    birthDateMinAge: "É necessário ser maior de 18 anos para contratar o seguro",
    completedTitle: "Cadastro já concluído",
    completedDescription:
      "Seu cadastro já está regularizado. Toque em continuar para prosseguir com a contratação do seu seguro.",
    warningTitle: "Advertência!",
    warningText1:
      "Este programa de seguros exige que o segurado ou beneficiário seja o destinatário da nota fiscal, sendo o protocolo realizado em seu nome.",
    warningText2:
      "A contratação deverá ser feita obrigatoriamente pelo destinatário ou por seu representante legal.",
    warningText3:
      "Se o destinatário for menor de idade, a contratação deve ser feita apenas por seu representante legal.",
    warningText4:
      "Em caso de sinistro, a reposição será feita diretamente ao destinatário. Para menores de idade, a reposição será realizada ao representante legal.",
    radioLabel: "Sou cônjuge, descendente ou ascendente do destinatário da nota fiscal.",
    cancelButton: "Cancelar",
    continueButton: "Continuar",
    danfeTitle: "DANFE - Form Bike",
  },

  en: {
    pageTitle: "Your data",
    mainTitle: "Complete your registration",
    cpfLabel: "CPF",
    birthDateLabel: "Date of birth",
    birthDateRequired: "Enter your date of birth",
    birthDateInvalid: "Invalid date of birth",
    birthDateMinAge: "You must be 18 years or older to purchase the insurance",
    completedTitle: "Registration completed",
    completedDescription:
      "Your registration has already been completed. Tap Continue to proceed with your insurance contract.",
    warningTitle: "Warning!",
    warningText1:
      "This insurance program requires that the insured or beneficiary be the recipient of the tax invoice, with the protocol carried out in their name.",
    warningText2:
      "The contract must be made obligatorily by the recipient or their legal representative.",
    warningText3:
      "If the recipient is a minor, the contract must be made only by their legal representative.",
    warningText4:
      "In case of loss, replacement will be made directly to the recipient. For minors, replacement will be made to the legal representative.",
    radioLabel: "I am a spouse, descendant or ascendant of the tax invoice recipient.",
    cancelButton: "Cancel",
    continueButton: "Continue",
    danfeTitle: "DANFE - Form Bike",
  },
};
